export default class ProductPartsDataProvider {
  constructor(ProductPartsService, db) {
    "ngInject"
    this.ProductPartsService = ProductPartsService;
    this.colors = db.getCollection("colors");
    this.shapes = db.getCollection("shapes");
    this.fixmethods = db.getCollection("fix_methods");
    this.db = db;
  }

  loadShapes() {
    return this.ProductPartsService
      .loadAllShapes()
      .then((shapes) => {
        this.shapes.insert(shapes);
        return shapes;
      })
  }

  loadFixmethods() {
    return this.ProductPartsService
      .loadAllFixmethods()
      .then((fixmethods) => {
        this.fixmethods.insert(fixmethods);
        return fixmethods;
      })
  }

  loadColors() {
    return this.ProductPartsService
      .loadAllColors()
      .then((colors) => {
        this.colors.insert(colors);
        return colors;
      })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-parts/parts.dataprovider.service.js
 **/